<!--
 * @Description: 教职工详情 组织考察
 * @Author: 张天伟
 * @Date: 2023-03-08 17:09:44
 * @LastEditors: PF
 * @LastEditTime: 2024-10-15 16:50:05
-->

<template>
  <div>
    <el-descriptions class="descript-box" v-for="(item, index) in tableData" :key="index" :column="4" border>
      <el-descriptions-item label="考察（考核）类别" label-align="right" align="left" width="191px" span="2">{{item.kclbbt}}</el-descriptions-item>
      <el-descriptions-item label="考察（考核）日期" label-align="right" align="left" width="191px" span="2">{{item.kcrq}}</el-descriptions-item>
      <el-descriptions-item label="考察（考核）结果" label-align="right" align="left" width="191px" span="2">{{item.kcjgbt}}</el-descriptions-item>
      <el-descriptions-item label="考察（考核）组织及考察人" label-align="right" align="left" width="191px" span="2">{{item.kczzjkcr}}</el-descriptions-item>
      <el-descriptions-item label="考察（考核）原因" label-align="right" align="left" width="191px" span="4">{{item.kcyj}}</el-descriptions-item>
      <el-descriptions-item label="" label-align="right" align="left" span="4"></el-descriptions-item>
    </el-descriptions>
  </div>
</template>

<script setup>
import { ref, defineProps, watch } from 'vue'
import { actionPost } from '@/api/common.js'

const props = defineProps({ row: { type: Object, required: false } })
const tableData = ref()

watch(
  () => props.row,
  () => {
    if (props.row) {
      const o = { url: '/api/v2/renliziyuan/jiaozhigongzuzhikaocha/list', data: { id: props.row.id, order: 'gh', sort: 'asc' } }
      actionPost(o).then((res) => {
        tableData.value = res.data
      })
    }
  },
  { deep: true, immediate: true }
)
</script>
